import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './index.css';
import reportWebVitals from './reportWebVitals';
import RootPage from './RootPage';
import PrivacyPolicyPage from "./PrivacyPolicyPage"
import DeleteData from './DeleteData';
import Background from './components/Background';
import ElGalle from './components/ElGalle';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
    <Background/>
      <Routes>
        <Route path="/" element={<RootPage />} />
        <Route path='/clients/elGalle' element={<ElGalle/>}/>
        <Route path="/privacyPolicy" element={<PrivacyPolicyPage />} />
        <Route path='/myInfo' element={<DeleteData />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();